import { NotifyErrorWrapper, NotifySuccess } from '@/helpers/core/notifications'
import { createPPA, deletePPA, getPPAs } from '@/services/eos/ppa.service'
import type { IPPAFilters } from '@/types/eos/filters'
import type { IPPAForm } from '@/types/eos/forms'
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'

export const usePPA = () => {
  const queryClient = useQueryClient()

  const getPPAsQuery = (filters: IPPAFilters) =>
    useQuery({
      queryKey: ['ppas', filters],
      queryFn: () => getPPAs(filters),
    })

  const createPPAMutation = useMutation({
    mutationFn: (form: IPPAForm) => createPPA(form),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['ppas'] })
      NotifySuccess('PPA created')
    },
    onError: NotifyErrorWrapper('Failed to create PPA'),
  })

  const deletePPAMutation = useMutation({
    mutationFn: (id: number) => deletePPA(id),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['ppas'] })
      NotifySuccess('PPA deleted')
    },
    onError: NotifyErrorWrapper('Failed to delete PPA'),
  })

  return {
    getPPAsQuery,
    createPPAMutation,
    deletePPAMutation,
  }
}
